<template>
  <van-popup v-model="show" get-container="#app" round position="bottom">
    <div class="pop-outer">
      <div class="pop-inner">
        <div class="filter-item" v-show="buildList.length > 0">
          <div class="filter-item-title">
            <div class="title-bar"></div>
            <div class="title-content">宿舍楼</div>
          </div>
          <div class="filter-item-content">
            <filterCheckBox bgColor="rgb(224,232,246)" v-model="form.buildList" :optionList="buildList" :props="{ label: 'dormOrganName', value: 'dormOrganId' }" hasAll="all"></filterCheckBox>
          </div>
        </div>
        <div class="filter-item" v-show="classDataList.length > 0">
          <div class="filter-item-title">
            <div class="title-bar"></div>
            <div class="title-content">班级</div>
          </div>
          <div class="filter-item-content">
            <!-- <infineTab v-model="form.classList" :optionList="classDataList" tabLabel="className" tabValue="id" hasAll="all"></infineTab> -->
            <filterRadio v-model="form.classList" :optionList="classDataList" tabLabel="className" tabValue="id" hasAll="all"></filterRadio>
          </div>
        </div>
        <div class="filter-item" v-show="deptDataList.length > 0">
          <div class="filter-item-title">
            <div class="title-bar"></div>
            <div class="title-content">部门</div>
          </div>
          <div class="filter-item-content">
            <!-- <infineTab v-model="form.deptList" :optionList="deptDataList" tabLabel="deptName" tabValue="id" hasAll="all"></infineTab> -->
            <filterRadio v-model="form.deptList" :optionList="deptDataList" tabLabel="deptName" tabValue="id" hasAll="all" :checkOut="true"></filterRadio>
          </div>
        </div>
        <div class="filter-item" v-if="timeTypeList.length>0">
          <div class="filter-item-title">
            <div class="title-bar"></div>
            <div class="title-content">时段</div>
          </div>
          <div class="filter-item-content">
            <!-- <infineTab v-model="form.deptList" :optionList="deptDataList" tabLabel="deptName" tabValue="id" hasAll="all"></infineTab> -->
            <filterRadio v-model="form.timeType" :optionList="timeTypeList" tabLabel="showValue" tabValue="subValue" :checkOut="true"></filterRadio>
          </div>
        </div>
        <div class="filter-item">
          <div class="filter-item-title">
            <div class="title-bar"></div>
            <div class="title-content">时间</div>
          </div>
          <div class="filter-item-content">
            <!-- <filterCalendar v-model="form.date"></filterCalendar> -->
            <filterDate v-model="form.date" class="filter-date"></filterDate>
          </div>
        </div>
        <div class="filter-item">
          <div class="filter-item-title">
            <div class="title-bar"></div>
            <div class="title-content">姓名</div>
          </div>
          <div class="filter-item-content">
            <div class="filter-input">
              <div class="search-icon">
                <img src="./search-icon.png" />
              </div>
              <input placeholder="请输入学生姓名" v-model="form.userName" />
            </div>
          </div>
        </div>
      </div>
      <div class="header-box">
        <div>全部筛选</div>
        <div class="close-btn" @click="closePop">
          <van-icon name="cross" />
        </div>
      </div>
    </div>
    <div class="pop-button">
      <div class="reset-button" @click="reset">
        重置
      </div>
      <div class="confirm-button" @click="confirm">
        完成
      </div>
    </div>
  </van-popup>
</template>

<script>
import filterRadio from './filterRadio.vue';
import filterCheckBox from './filterCheckBox.vue';
import filterCalendar from './filterCalendar.vue';
import filterDate from './filterDate.vue';
import infineTab from './infineTab.vue';
import moment from 'moment';
export default {
  components: { filterRadio, filterCheckBox, filterCalendar, infineTab, filterDate },
  props: {
    classDataList: {
      type: Array,
      default: () => []
    },
    deptDataList: {
      type: Array,
      default: () => []
    },
    buildList: {
      type: Array,
      default: () => []
    },
    timeTypeList:{
      type:Array,
      default:()=>[]
    }
  },
  data() {
    return {
      show: false,
      form: {
        buildList: ['all'],
        classList: ['all'],
        deptList: [],
        date: moment(new Date()).format('YYYY-MM-DD'),
        userName: null,
        timeType:[]
      }
    };
  },
  watch: {
    'form.buildList': function(newVal, oldVal) {
      if (newVal.length == 1 && newVal[0] == 'all') {
        this.$emit('getSelectFloorTimeType', this.buildList.map(item => item.dormOrganId));
      } else {
        this.$emit('getSelectFloorTimeType', newVal);
      }
    }
  },
  methods: {
    open(data) {
      this.show = true;
      this.form = JSON.parse(JSON.stringify({ ...this.form, ...data }));
    },
    closePop() {
      this.show = false;
      // this.form.buildList =['all']
      // this.form.classList =['all']
      // this.form.date = moment(new Date()).format('YYYY-MM-DD')
      // this.form.userName =null
    },
    reset() {
      this.form.buildList = ['all'];
      this.form.classList = ['all'];
      this.form.deptList = [];
      this.form.date = moment(new Date()).format('YYYY-MM-DD');
      this.form.userName = null;
    },
    confirm() {
      this.show = false;
      let confirmData = JSON.parse(JSON.stringify(this.form));
      this.$emit('confirm', confirmData);
    }
  }
};
</script>

<style lang="scss" scoped>
.pop-outer {
  padding: 8vh 2vh 2vh 2vh;
  // max-height: 30vh;
  // min-height: 30vh;
  // height: 30vh;
  position: relative;
  font-size: 0.9rem;
  .pop-inner {
    max-height: 60vh;
    overflow: auto;
    .filter-item-title {
      display: flex;
      margin: 0.625rem 0;
      // align-items: center;
      .title-bar {
        width: 0.1875rem;
        height: 0.8rem;
        border-radius: 0.1rem;
        background-color: #3775ff;
      }
      .title-content {
        line-height: 1;
        padding-left: 0.5rem;
      }
    }
    .filter-item-content {
      // margin-top: 0.625rem;
    }
  }
  .header-box {
    position: absolute;
    left: 0;
    top: 0;
    height: 8vh;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    .close-btn {
      position: absolute;
      right: 2vh;
      // top: 2vh;
      font-size: 1rem;
    }
  }
  .filter-input {
    width: 100%;
    display: flex;
    border-radius: 0.9375rem;
    background-color: rgb(224, 232, 246);
    overflow: hidden;
    align-items: center;
    padding-right: 1rem;
    .search-icon {
      text-align: center;
      width: 2.125rem;
      flex-shrink: 0;
      padding-top: 0.2rem;
      padding-left: 0.2rem;
      img {
        height: 0.9rem;
      }
    }
    input {
      width: calc(100% - 2.2125rem);
      height: 1.875rem;
      border: 0;
      outline: 0;
      flex: 1;
      padding: 0.4375rem 0;
      font-size: 0.75rem;
      color: #333;
      background: transparent;
      &::placeholder {
        color: #999;
      }
    }
  }
}
.pop-button {
  height: 3rem;
  display: flex;
  justify-content: space-around;
  & > * {
    text-align: center;
    display: inline-block;
    height: 2.5rem;
    width: 10.875rem;
    border-radius: 1.25rem;
    line-height: 2.5rem;
    font-size: 0.875rem;
  }
  .reset-button {
    background-color: rgb(224, 232, 246);
  }
  .confirm-button {
    color: #fff;
    background-color: #3775ff;
  }
}
.filter-date::v-deep.date-box {
  font-size: 0.8rem;
  .date-arrow{
    padding: 0.3rem;
    background-color: rgb(224, 232, 246);
    border-radius: 1rem;
  }
  .date-show{
    padding: 0.3rem 1rem;
    background-color: rgb(224, 232, 246);
    border-radius: 1rem;
  }
}
</style>
